import React from 'react';

export const HeroBanner = ({ title, subtitle, imageUrl }) => {
  return (
    <div className="bg-white border border-slate-200 shadow-xs overflow-hidden flex flex-row justify-between items-center relative min-h-[70px]">
      <div className="p-3.5 md:p-4 flex flex-col justify-center z-10 max-w-xl">
        <h1 className="text-base md:text-lg font-bold text-slate-900 tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-[9px] md:text-[10px] text-slate-400 font-medium tracking-wide mt-0.5">
            {subtitle}
          </p>
        )}
      </div>

      <div
        className="w-1/2 h-full absolute right-0 top-0 bottom-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('${imageUrl || 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1000&q=80'}')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/50 to-transparent"></div>
      </div>
    </div>
  );
};
